import { getToken } from './user-service';

const BASE_URL = '/api/v1/cpu/sla-reports/employeeAuditReport';

/**
 * Fetch employee audit report (geolocations + beacon events) from the backend.
 *
 * @param {Object} params
 * @param {string} params.iata - Airport IATA code
 * @param {string} params.employeeId - Employee ID
 * @param {string} params.startDate - Start datetime (ISO string)
 * @param {string} params.endDate - End datetime (ISO string)
 * @returns {Promise<{ geolocations: Array, beaconEvents: Array }>}
 */
export const getEmployeeAuditReport = async (params) => {
  const token = await getToken();
  const { iata, employeeId, startDate, endDate } = params;
  const queryParams = new URLSearchParams({
    iata,
    employeeId,
    startDate,
    endDate,
  });
  const response = await fetch(`${BASE_URL}?${queryParams.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
      'Firebase-UID': token,
    },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Employee audit report failed: ${response.status}`);
  }
  return response.json();
};
